"use strict";
exports.__esModule = true;
exports["default"] = function(Handlebars) {
  (function() {
    if (typeof globalThis === "object") return;
    Object.prototype.__defineGetter__("__magic__", function() {
      return this;
    });
    __magic__.globalThis = __magic__;
    delete Object.prototype.__magic__;
  })();
  var $Handlebars = globalThis.Handlebars;
  Handlebars.noConflict = function() {
    if (globalThis.Handlebars === Handlebars) {
      globalThis.Handlebars = $Handlebars;
    }
    return Handlebars;
  };
};
module.exports = exports["default"];
